import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var ErrorContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 3px;\n  min-height: 15px;\n"], ["\n  margin-top: 3px;\n  min-height: 15px;\n"])));
var templateObject_1;
